import axios from "axios";

export const mensajeErrorCancelacion = (error) => {
  if (error?.cancelacionRegistrada) return error.message;
  const mensaje = error?.response?.data?.message;
  if (typeof mensaje === "string" && mensaje.trim()) {
    return `No se pudo cancelar el turno: ${mensaje.trim()}`;
  }
  return "No se pudo cancelar el turno. Intente nuevamente.";
};

// Registrar primero la cancelación conserva el antecedente; luego se libera el horario.
export const cancelarYLiberarTurno = async (url, codigo, token) => {
  if (!codigo) throw new Error("No se pudo identificar el turno seleccionado.");

  const config = { headers: { Authorization: `Bearer ${token}` } };
  await axios.patch(`${url}Turnos/Cancelar/${codigo}`, "", config);
  try {
    await axios.patch(`${url}Turnos/Quitar/${codigo}`, "", config);
  } catch (error) {
    const fallo = new Error(
      "Se registró la cancelación, pero no se pudo confirmar la liberación del horario. Comuníquese con la institución."
    );
    fallo.cancelacionRegistrada = true;
    throw fallo;
  }
};
